const mobileZoom = require('./mobileZoom')
const isMobile = () => {
  return /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
function quantitySelector() {
  var quantitySelector = $('.quantity-selector');
  var quantitySelect = quantitySelector.find('.quantity-select');
  
  $('.quantity-minus').on('click', function () {
    var currentValue = parseInt(quantitySelect.val());
    if (currentValue > 1) {
      quantitySelect.val(currentValue - 1);
      quantitySelect.trigger('change');
    }
  });
  
  $('.quantity-plus').on('click', function () {
    var currentValue = parseInt(quantitySelect.val());
    quantitySelect.val(currentValue + 1);
    quantitySelect.trigger('change');
  });
  
  quantitySelect.on('mousedown', function (e) {
    e.preventDefault();
  });
}

function openRegisterModal() {
  $('#register-tab').on('click', function () {
    $('#accountModal').modal('hide');
    $('#registerModal').modal('show');
  });
}
function openAccountModal() {
  $('.wishlist-btn').on('click', function () {
    var isAuthenticated = $(this).data('authenticated');
    if (!isAuthenticated && !$(this).hasClass('remove-btn')) {
      $('#accountModal').modal('show');
    }
  });
}
function openAfterAddToCartModal() {
  $(document).on('product:afterAddToCart', function (e, data) {

    var color = $(".color-attribute .color-value.selected");
    var size = $(".selector-wrapper .talla-attribute.selected");
    var productAtributes = $("#afterAddToCartModal .content-cart-added .product-attributes");
    var cartCount = $("#afterAddToCartModal .modal-title span");
    cartCount.text(`(${data.quantityTotal})`);
    productAtributes.children().remove();
    var productImageContainer = $("#afterAddToCartModal .product-image-added");
    productImageContainer.children().remove();
    var firstImage = $("#carrousel-slide-images-container .carousel-item img")[0];
    $('.minicart-quantity-container .minicart-quantity').text(data.quantityTotal);
    if (color) {
      var colorAttribute = color.data("attr-value");
      productAtributes.append(`<p>Color: ${colorAttribute}</p>`)
    }
    if (size) {
      var sizeAtribute = size.find("span").data("attr-value")
      productAtributes.append(`<p>Talla: ${sizeAtribute}</p>`)
    }
    if (firstImage) {
      productImageContainer.append(`<img src="${firstImage.src}"></img>`);
    }
    if(!data.error){
      $('#afterAddToCartModal').modal('show');
      $('#afterAddToCartModal').on('shown.bs.modal', function () {
        $("body > .modal-backdrop").remove();
        $("body").removeClass('modal-open');
      });
    }
  });
}
function openSelectedImageModal() {
  $(document).on('click','.vertical-carousel .product-active-img , .pdp-carousel .carousel-item img', function () {
    var imageModal = $('#selectedImageModal');
    
    if (isMobile()) {
      var image = $(this).clone();
      image.addClass('product-modal-photo');
      imageModal.find('.modal-body .product-modal-image-container').empty().append(image)
    }
    imageModal.modal('show');
  });
};

function openRequestPasswordResetModal() {
  $('#requestPasswordResetModal').on('shown.bs.modal', function () {
    $('#accountModal').modal('hide');
  });
}
function removeDisabled() {
  function validateForm($form) {
    var $submitBtn = $form.find('.submit-btn, .register-btn');
    var $requiredInputs = $form.find('input[required]');

    function checkValidity() {
      var isValid = true;
      $requiredInputs.each(function () {
        if (!$(this).val().trim()) {
          isValid = false;
          return false;
        }
      });
      $submitBtn.prop('disabled', !isValid);
    }

    $requiredInputs.on('input', checkValidity);
  }
  validateForm($('.login'));
  validateForm($('.registration'));
}

function zoomImage() { 
  if (isMobile()) {
    $('#selectedImageModal').on('shown.bs.modal', function () {
      const $img = $('.product-modal-photo');
      const $container = $('.product-modal-image-container');
      mobileZoom($img, $container);
    });
  } else {
    $('#selectedImageModal').on('shown.bs.modal', function () {
      $('.product-modal-photo').wrap('<span style="display:inline-block"></span>')
        .css('display', 'block')
        .parent()
        .zoom();
    });
  }
}

module.exports = {
  zoomImage: zoomImage,
  quantitySelector: quantitySelector,
  openSelectedImageModal: openSelectedImageModal,
  openRegisterModal: openRegisterModal,
  openAfterAddToCartModal: openAfterAddToCartModal,
  openRequestPasswordResetModal: openRequestPasswordResetModal,
  removeDisabled: removeDisabled,
  openAccountModal: openAccountModal
}